export default "/34887f8f847f5d202a469a9dd4881160882f8c6b/569373b84d4fa61cda98164451d2ed57.svg";